// Constants for success/error messages
export const Messages = {
  LOGIN_SUCCESS: 'Đăng nhập thành công',
  LOGIN_ERROR: 'Đăng nhập thất bại',
  LOGOUT_SUCCESS: 'Đăng xuất thành công',
  REFRESH_TOKEN_SUCCESS: 'Làm mới token thành công',
  REFRESH_TOKEN_ERROR: 'Làm mới token thất bại',
  UPDATE_SUCCESS: 'Cập nhật thành công',
  UPDATE_ERROR: 'Cập nhật thất bại',
  FETCH_PROFILE_SUCCESS: 'Lấy thông tin profile thành công',
  FETCH_PROFILE_ERROR: 'Lấy thông tin profile thất bại',
  INVALID_CREDENTIALS: 'Tên đăng nhập hoặc mật khẩu không đúng',
  NETWORK_ERROR: 'Lỗi kết nối mạng',
  API_ERROR: 'Lỗi hệ thống. Vui lòng liên hệ với quản trị viên',
  CREATE_SUCCESS: 'Tạo thành công',
  DELETE_SUCCESS: 'Xóa thành công',
} as const;
